import { useState } from "react";
import { SelectProduct } from "../types/salon.types";

export const useOrderManagement = () => {
  const [selectedProducts, setSelectedProducts] = useState<SelectProduct[]>([]);
  const [discount, setDiscount] = useState("0");

  const addProduct = (product: SelectProduct) => {
    setSelectedProducts(prev => {
      const existingIndex = prev.findIndex(p => p._id.$oid === product._id.$oid);
      
      if (existingIndex >= 0) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          quantity: (updated[existingIndex].quantity || 1) + 1
        };
        return updated;
      } else {
        return [...prev, { ...product, quantity: 1 }];
      }
    });
  };

  const removeProduct = (productId: string) => {
    setSelectedProducts(prev => 
      prev.filter(product => product._id.$oid !== productId)
    );
  };

  const updateProductQuantity = (productId: string, newQuantity: number) => {
    console.log("🔄 updateProductQuantity called:", { productId, newQuantity });
    setSelectedProducts(prev => {
      const updated = prev.map(product => {
        if (product._id.$oid === productId) {
          console.log("✅ Found product, updating quantity from", product.quantity, "to", newQuantity);
          return { ...product, quantity: Math.max(1, newQuantity) };
        }
        return product;
      });
      console.log("📦 Updated products:", updated);
      return updated;
    });
  };

  const updateProductPrice = (productId: string, newPrice: string) => {
    console.log("💰 updateProductPrice called:", { productId, newPrice });
    setSelectedProducts(prev =>
      prev.map(product => {
        if (product._id.$oid === productId) {
          console.log("✅ Found product, updating price from", product.amount, "to", newPrice);
          return { ...product, amount: newPrice };
        }
        return product;
      })
    );
  };

  const clearOrder = () => {
    setSelectedProducts([]);
    setDiscount("0");
  };

  const calculateSubtotal = () => {
    return selectedProducts.reduce((total, product) => {
      return total + parseFloat(product.amount) * (product.quantity || 1);
    }, 0);
  };

  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const discountValue = parseFloat(discount) || 0;
    return Math.max(subtotal - discountValue, 0);
  };

  return {
    selectedProducts,
    discount,
    setDiscount,
    addProduct,
    removeProduct,
    updateProductQuantity,
    updateProductPrice,
    clearOrder,
    calculateSubtotal,
    calculateTotal
  };
};